import { api } from 'lib/httpClient';
import { ApiResponse } from 'further-types/api';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { Api } from 'further-types/investor';

const fetchDefaultAdviser = async ({
  email,
  firmId,
}: {
  email?: string;
  firmId?: string;
}) => {
  const {
    data: { data },
  } = await api.get<ApiResponse<Api.GetDefaultAdviserResponse>>(
    `investor/default-adviser`,
    {
      params: {
        email,
        firmId,
      },
      headers: { 'Cache-Control': 'no-cache' },
    },
  );
  return data.adviserId;
};

export const useDefaultAdviser = (email?: string, firmId?: string) => {
  const queryClient = useQueryClient();

  const queryKey = 'get-default-adviser';

  const defaultAdviser = useQuery({
    queryKey: [queryKey, email, firmId],
    queryFn: () => fetchDefaultAdviser({ email, firmId }),
    enabled: !!email,
  });

  const runQuery = async (investorEmail: string, investorFirmId?: string) => {
    return queryClient.fetchQuery({
      queryKey: [queryKey, investorEmail],
      queryFn: () =>
        fetchDefaultAdviser({ email: investorEmail, firmId: investorFirmId }),
    });
  };

  return {
    defaultAdviser,
    runQuery,
  };
};
